export const formatPresenceDate = (value) => {
  if (!value) return "—";

  const parsedDate = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(parsedDate.getTime())) return "—";

  const year = parsedDate.getFullYear();
  const month = `${parsedDate.getMonth() + 1}`.padStart(2, "0");
  const day = `${parsedDate.getDate()}`.padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getPresenceKind = (presence) => {
  if (presence?.staff) return "personnel";
  if (presence?.student) return "eleve";
  return "autre";
};

export const getPresenceOwnerLabel = (presence) => {
  const staff = presence?.staff;
  if (staff) {
    const firstName = staff?.user?.first_name || "";
    const lastName = staff?.user?.last_name || "";
    const familyName = staff?.user?.family_name || "";
    const matricule = staff?.matricule ? `${staff.matricule} ` : "";
    return `${matricule}${lastName} ${familyName} ${firstName} `.trim() || "Personnel";
  }

  const student = presence?.student;
  const firstName = student?.user?.first_name || student?.first_name || "";
  const lastName = student?.user?.last_name || student?.last_name || "";
  const familyName = student?.user?.family_name || student?.last_name || "";
  const matricule = student?.matricule ? `${student.matricule} ` : "";

  return `${matricule}${lastName} ${ familyName } ${firstName}`.trim() || "Élève";
};

export const getPresenceClassLabel = (presence) => {
  const student = presence?.student;
  const sectionclass = student?.sectionclass || student?.sectionclasse || {};
  const className = sectionclass?.class?.short_entitled_class || sectionclass?.class?.entitled_class || "";
  const title = sectionclass?.title || "";
  const sectionName = sectionclass?.section?.short_entitled_section || sectionclass?.section?.entitled_section || "";
  const parts = [className, title, sectionName].filter(Boolean);

  return parts.join(" ").trim() || "—";
};

export const groupStudentsBySectionAndClass = (students = []) => {
  const sections = new Map();

  (students || []).forEach((student) => {
    const sectionClass = student?.sectionclass || student?.sectionclasse;
    const section = sectionClass?.section;

    if (!section?.id || !sectionClass?.id) return;

    if (!sections.has(section.id)) {
      sections.set(section.id, { section, classes: new Map() });
    }

    const sectionGroup = sections.get(section.id);
    if (!sectionGroup.classes.has(sectionClass.id)) {
      sectionGroup.classes.set(sectionClass.id, { sectionClass, students: [] });
    }

    sectionGroup.classes.get(sectionClass.id).students.push(student);
  });

  return [...sections.values()]
    .sort((a, b) => (a.section?.entitled_section || "").localeCompare(b.section?.entitled_section || ""))
    .map((group) => ({
      ...group,
      classes: [...group.classes.values()].sort((a, b) => {
        const aLabel = `${a.sectionClass?.class?.short_entitled_class || ""} ${a.sectionClass?.title || ""}`;
        const bLabel = `${b.sectionClass?.class?.short_entitled_class || ""} ${b.sectionClass?.title || ""}`;
        return aLabel.localeCompare(bLabel, "fr", { numeric: true });
      }),
    }));
};

export const summarizePresences = (presences = []) => {
  const uniqueStudents = new Set();
  const uniqueClasses = new Set();

  (presences || []).forEach((presence) => {
    const student = presence?.student;
    if (student?.id) {
      uniqueStudents.add(student.id);
    }

    const sectionclass = student?.sectionclass || student?.sectionclasse || {};
    const classKey = [
      sectionclass?.class?.short_entitled_class || sectionclass?.class?.entitled_class || "",
      sectionclass?.title || "",
      sectionclass?.section?.short_entitled_section || sectionclass?.section?.entitled_section || "",
    ].filter(Boolean).join("|");

    if (classKey) {
      uniqueClasses.add(classKey);
    }
  });

  return {
    total: (presences || []).length,
    students: uniqueStudents.size,
    classes: uniqueClasses.size,
  };
};

export const getClassPresenceSummary = (students = [], presences = []) => {
  const todayKey = formatPresenceDate(new Date());
  const studentIds = new Set((students || []).map((student) => student?.id).filter(Boolean));

  let total = 0;
  let totalToday = 0;

  (presences || []).forEach((presence) => {
    const studentId = presence?.student?.id ?? presence?.studentId;
    if (!studentIds.has(studentId)) return;

    total += 1;
    if (formatPresenceDate(presence?.date) === todayKey) {
      totalToday += 1;
    }
  });

  return { total, totalToday };
};
